import { request } from './client'

function buildQuery(params = {}) {
  const search = new URLSearchParams()
  if (params.states?.length) search.set('states', params.states.join(','))
  if (params.countries?.length) search.set('countries', params.countries.join(','))
  if (params.tags?.length) search.set('tags', params.tags.join(','))
  if (params.limit) search.set('limit', String(params.limit))
  return search.toString()
}

export const fetchVenues = ({ states = [], countries = [], tags = [], limit = 50 } = {}) => {
  const query = buildQuery({ states, countries, tags, limit })
  const suffix = query ? `?${query}` : ''
  return request(`/venues/digest${suffix}`).then((payload) => (Array.isArray(payload) ? payload : []))
}

export const fetchVenueDetail = (venueId) => request(`/venues/${encodeURIComponent(venueId)}`)

export const createVenueOpportunities = (body) =>
  request('/venues/opportunities', {
    method: 'POST',
    body,
  })
